module.exports = __webpack_public_path__ + "img/doc.3d214ece.png";